import React from 'react';
import { Button, Drawer, Form, Input, Select, Space, Table } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import styled from 'styled-components';

export const GroupMobilePage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 13px;
  box-sizing: border-box;
  width: calc(100% + 32px);
  max-width: none;
  margin: 0 -16px;
  padding: 0 20px 24px;
  overflow-x: hidden;
  background: #ffffff;
`;

export const GroupMobileHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: calc(100% + 40px);
  min-height: 56px;
  margin: 0 -20px;
  padding: 12px 20px;
  border-bottom: 1px solid #d9d9d9;
  background: #ffffff;
`;

export const GroupMobileHeaderCopy = styled.div`
  min-width: 0;

  h1 {
    width: 120px;
    margin: 0;
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  p {
    margin: 2px 0 0;
    color: #6b7280;
    font-size: 12px;
    line-height: 18px;
  }
`;

export const GroupMobileBackButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: #111827;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const GroupMobileHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 12px;
`;

export const GroupMobileActionButton = styled(Button)`
  && {
    min-width: 73px;
    height: 32px;
    padding: 6px 20px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
  }
`;

export const GroupMobileSecondaryButton = styled(Button)`
  && {
    min-width: 86px;
    height: 32px;
    padding: 6px 20px;
    border-color: #d9d9d9;
    border-radius: 6px;
    background: #ffffff;
    color: #595959;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
  }
`;

export const GroupMobileHeaderActions = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 8px;
`;

export const GroupMobileIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: #264284;
  color: #ffffff;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const GroupMobileFilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export const GroupMobileSearch = styled(Input)`
  &&,
  &&.ant-input-affix-wrapper {
    flex: 1 1 auto;
    min-width: 0;
    height: 44px;
    padding: 0 10px;
    border-color: #e8ecf3;
    border-radius: 6px;
    background: #ffffff;
    color: #1e1e1e;
    font-size: 14px;
  }

  && .ant-input {
    height: 42px;
    padding: 0;
    border: 0;
    background: transparent;
    box-shadow: none;
    color: #1e1e1e;
    font-size: 14px;
    line-height: 22px;
  }

  && .ant-input::placeholder {
    color: #bfbfbf;
  }

  && .ant-input-suffix {
    margin-inline-start: 10px;
    color: #9facbf;
    font-size: 24px;
  }

  && .ant-input-suffix svg {
    width: 24px;
    height: 24px;
  }
`;

export const GroupMobileFilterButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 1px solid #e8ecf3;
  border-radius: 6px;
  background: #ffffff;
  color: #1e1e1e;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const GroupMobileTableCard = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  background: #ffffff;

  .ant-table-wrapper,
  .ant-spin-nested-loading,
  .ant-spin-container,
  .ant-table,
  .ant-table-container,
  .ant-table-content,
  table {
    width: 839px !important;
    min-width: 839px !important;
  }

  .ant-table {
    font-size: 12px;
  }

  .ant-table-thead > tr,
  .ant-table-tbody > tr {
    box-shadow: inset 0 -1px 0 #e8ecf3;
  }

  .ant-table-thead > tr > th {
    height: 46px;
    padding: 12px;
    box-sizing: border-box;
    border-right: 1px solid #d9d9d9;
    border-bottom: 0;
    background: #fafafa;
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
  }

  .ant-table-thead > tr > th:last-child {
    border-right: 0;
  }

  .ant-table-tbody > tr > td {
    height: 48px;
    padding: 16px 12px;
    box-sizing: border-box;
    border-bottom: 0;
    color: #1e1e1e;
    font-size: 12px;
    line-height: 1.2;
    white-space: nowrap;
  }

  .ant-tag {
    margin-inline-end: 0;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }
`;

export const GroupMobilePagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-height: 40px;
`;

export const GroupMobilePaginationInfo = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  color: #9facbf;
  font-size: 12px;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const GroupMobilePaginationActions = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 6px;
  height: 40px;
`;

export const GroupMobilePageButton = styled.button<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  box-sizing: border-box;
  flex: 0 0 32px;
  padding: 0;
  border: 1px solid ${(props) => (props.$active ? '#272a35' : '#e8ecf3')};
  border-radius: 4px;
  background: #ffffff;
  color: ${(props) => (props.disabled ? '#c5cddb' : '#1e1e1e')};
  font-size: 14px;
  line-height: 22px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const GroupMobileForm = styled.div`
  width: 100%;
  padding: 12px 0 24px;
`;

export const GroupMobileSection = styled.section<{ $bordered?: boolean }>`
  width: 100%;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: ${(props) => (props.$bordered ? '1px solid #d9d9d9' : '0')};
`;

export const GroupMobileSectionHeader = styled.div`
  margin-bottom: 8px;

  h2 {
    margin: 0;
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
  }

  p {
    margin: 2px 0 0;
    color: #768499;
    font-size: 12px;
    line-height: 1.2;
  }
`;

export const GroupMobileField = styled(Form.Item)`
  && {
    width: 100%;
    margin: 0 0 8px;
  }

  .ant-form-item-label {
    padding-bottom: 4px;
  }

  .ant-form-item-label > label {
    height: auto;
    color: #000000;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
  }

  .ant-form-item-label > label.ant-form-item-required::before {
    color: #ff3a3a;
  }

  .ant-input,
  .ant-select-selector {
    min-height: 44px;
    border-color: #e8ecf3 !important;
    border-radius: 6px !important;
    box-shadow: none !important;
    font-size: 12px;
  }

  .ant-select-selector {
    height: 44px !important;
    display: flex;
    align-items: center;
    padding: 0 10px !important;
  }

  .ant-select-selection-search {
    inset-inline-start: 10px !important;
    inset-inline-end: 32px !important;
  }

  .ant-select-selection-search-input {
    height: 42px !important;
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    display: flex;
    align-items: center;
    height: 42px;
    line-height: 1.2 !important;
  }

  .ant-input::placeholder,
  .ant-select-selection-placeholder {
    color: #bfbfbf;
    font-size: 12px;
  }

  .ant-select-arrow {
    color: #9facbf;
    font-size: 14px;
  }
`;

export const GroupMobileSwitchField = styled(GroupMobileField)`
  && {
    margin-bottom: 0;
  }

  .ant-form-item-label {
    padding-bottom: 4px;
  }

  .ant-form-item-control-input {
    min-height: 22px;
  }

  .ant-switch {
    min-width: 44px;
    height: 22px;
  }

  .ant-switch-handle {
    width: 18px;
    height: 18px;
  }

  .ant-switch-checked .ant-switch-handle {
    inset-inline-start: calc(100% - 20px);
  }
`;

export const GroupMobileDetailRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const GroupMobileDetailRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
`;

export const GroupMobileDetailLabel = styled.span`
  width: 100%;
  color: #768499;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.2;
`;

export const GroupMobileDetailValue = styled.span`
  width: 100%;
  min-width: 0;
  color: #000000;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  text-align: left;
  word-break: break-word;

  .ant-tag {
    margin: 0;
    padding: 0 8px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }
`;

export const GroupMobileDetailSection = styled.section<{
  $bordered?: boolean;
}>`
  width: 100%;
  margin-bottom: 12px;
  padding-bottom: 24px;
  border-bottom: ${(props) => (props.$bordered ? '1px solid #d9d9d9' : '0')};
`;

export const GroupMobileDetailSectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-bottom: 12px;

  h2 {
    margin: 0;
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
  }

  p {
    margin: 0;
    color: #768499;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.2;
  }
`;

export const GroupMobileAlert = styled.div`
  margin-bottom: 12px;
`;

export const GroupMobileInlineActions = styled(Space)`
  && {
    gap: 8px !important;
  }
`;

export const GroupMobileDataTable = styled(Table)`
  width: 100%;

  .ant-table-container {
    overflow: hidden;
    border-radius: 12px 12px 0 0;
  }

  .ant-table-content table {
    min-width: 957px;
  }

  && .ant-table-thead > tr > th {
    height: 46px;
    padding: 12px;
    border-right: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
    background: #fafafa;
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    white-space: nowrap;
  }

  && .ant-table-thead > tr > th:last-child {
    border-right: 0;
  }

  && .ant-table-tbody > tr > td {
    height: 48px;
    padding: 16px 12px;
    border-bottom: 1px solid #e8ecf3;
    color: #1e1e1e;
    font-size: 12px;
    line-height: 1.2;
    white-space: nowrap;
  }

  .ant-tag {
    margin: 0;
    padding: 0 8px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }

  .ant-image-img {
    object-fit: contain;
  }
`;

export const GroupMobileFilterDrawer = styled(Drawer)`
  &&.ant-drawer-bottom > .ant-drawer-content-wrapper {
    border-radius: 8px 8px 0 0;
    overflow: hidden;
  }

  .ant-drawer-content {
    border-radius: 8px 8px 0 0;
    overflow: hidden;
    background: #ffffff;
  }

  .ant-drawer-header {
    padding: 16px 12px;
    border-bottom: 1px solid #e8ecf3;
  }

  .ant-drawer-header-title {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .ant-drawer-title {
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
  }

  .ant-drawer-close {
    width: 24px;
    height: 24px;
    margin: 0;
    padding: 0;
    color: #1e1e1e;
  }

  .ant-drawer-body {
    padding: 0 0 12px;
  }
`;

export const GroupMobileFilterForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const GroupMobileFilterFields = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 12px;
`;

export const GroupMobileFilterField = styled.label`
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
  color: #768499;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
`;

export const GroupMobileFilterSelect = styled(Select)`
  && {
    width: 100%;
  }

  && .ant-select-selector {
    height: 44px !important;
    padding: 0 8px !important;
    border-color: #e8ecf3 !important;
    border-radius: 6px !important;
    box-shadow: none !important;
  }

  && .ant-select-selection-item {
    color: #1e1e1e;
    font-size: 12px;
    font-weight: 400;
    line-height: 42px !important;
  }

  && .ant-select-arrow {
    color: #9facbf;
    right: 8px;
    width: 24px;
    height: 24px;
    margin-top: -12px;
    font-size: 14px;
    line-height: 24px;
  }

  && .ant-select-arrow svg {
    width: 14px;
    height: 14px;
  }
`;

export const GroupMobileFilterActions = styled.div`
  display: flex;
  width: 100%;
  padding: 0 20px;
`;

export const GroupMobileFilterApplyButton = styled(Button)`
  && {
    width: 100%;
    height: 44px;
    border: 0;
    border-radius: 6px;
    background: #264284;
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.2;
  }

  &&:hover,
  &&:focus {
    background: #264284;
    color: #ffffff;
  }
`;

type MobileHeaderProps = {
  title: string;
  subtitle?: string;
  onBack?: () => void;
  action?: React.ReactNode;
};

export const MobileGroupHeader = ({
  title,
  subtitle,
  onBack,
  action,
}: MobileHeaderProps) => (
  <GroupMobileHeader>
    <GroupMobileHeaderLeft>
      {onBack ? (
        <GroupMobileBackButton type="button" onClick={onBack} aria-label="Back">
          <LeftOutlined />
        </GroupMobileBackButton>
      ) : null}
      <GroupMobileHeaderCopy>
        <h1>{title}</h1>
        {subtitle ? <p>{subtitle}</p> : null}
      </GroupMobileHeaderCopy>
    </GroupMobileHeaderLeft>
    {action}
  </GroupMobileHeader>
);
